import { render } from "./RevenueBlock.vue?vue&type=template&id=d4abe6b8"
import script from "./RevenueBlock.vue?vue&type=script&lang=js"
export * from "./RevenueBlock.vue?vue&type=script&lang=js"

import "./RevenueBlock.vue?vue&type=style&index=0&id=d4abe6b8&lang=css"

import exportComponent from "C:\\Development\\konnektor\\scores\\kon-platform-wallboards-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__